module.exports = __webpack_public_path__ + "static/media/networker-badge.be1acbd7.svg";